// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/gateway/web/myprofile/v1/client_events.proto (package gdx.gateway.web.myprofile.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * Available survey types.
 *
 * @generated from enum gdx.gateway.web.myprofile.v1.SurveyType
 */
export enum SurveyType {
  /**
   * @generated from enum value: SURVEY_TYPE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: SURVEY_TYPE_OFFBOARDING_DELETE = 1;
   */
  OFFBOARDING_DELETE = 1,

  /**
   * @generated from enum value: SURVEY_TYPE_OFFBOARDING_UNSUBSCRIBE = 2;
   */
  OFFBOARDING_UNSUBSCRIBE = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(SurveyType)
proto3.util.setEnumType(SurveyType, "gdx.gateway.web.myprofile.v1.SurveyType", [
  { no: 0, name: "SURVEY_TYPE_INVALID" },
  { no: 1, name: "SURVEY_TYPE_OFFBOARDING_DELETE" },
  { no: 2, name: "SURVEY_TYPE_OFFBOARDING_UNSUBSCRIBE" },
]);

/**
 * Register a visit to a visited user by currently logged in user.
 *
 * @generated from message gdx.gateway.web.myprofile.v1.ProfileVisitedEvent
 */
export class ProfileVisitedEvent extends Message<ProfileVisitedEvent> {
  /**
   * @generated from field: string visited_user_id = 1;
   */
  visitedUserId = "";

  constructor(data?: PartialMessage<ProfileVisitedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.ProfileVisitedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "visited_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileVisitedEvent {
    return new ProfileVisitedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileVisitedEvent {
    return new ProfileVisitedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileVisitedEvent {
    return new ProfileVisitedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileVisitedEvent | PlainMessage<ProfileVisitedEvent> | undefined, b: ProfileVisitedEvent | PlainMessage<ProfileVisitedEvent> | undefined): boolean {
    return proto3.util.equals(ProfileVisitedEvent, a, b);
  }
}

/**
 * Stored by client when user completes onboarding process.
 *
 * @generated from message gdx.gateway.web.myprofile.v1.OnboardingCompleteClientEvent
 */
export class OnboardingCompleteClientEvent extends Message<OnboardingCompleteClientEvent> {
  /**
   * @generated from field: uint32 engagement_score = 1;
   */
  engagementScore = 0;

  /**
   * @generated from field: uint32 photos_uploaded_count = 2;
   */
  photosUploadedCount = 0;

  constructor(data?: PartialMessage<OnboardingCompleteClientEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.OnboardingCompleteClientEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "engagement_score", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "photos_uploaded_count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OnboardingCompleteClientEvent {
    return new OnboardingCompleteClientEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OnboardingCompleteClientEvent {
    return new OnboardingCompleteClientEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OnboardingCompleteClientEvent {
    return new OnboardingCompleteClientEvent().fromJsonString(jsonString, options);
  }

  static equals(a: OnboardingCompleteClientEvent | PlainMessage<OnboardingCompleteClientEvent> | undefined, b: OnboardingCompleteClientEvent | PlainMessage<OnboardingCompleteClientEvent> | undefined): boolean {
    return proto3.util.equals(OnboardingCompleteClientEvent, a, b);
  }
}

/**
 * Stored by client when user click on web push notification.
 *
 * @generated from message gdx.gateway.web.myprofile.v1.WebPushClickClientEvent
 */
export class WebPushClickClientEvent extends Message<WebPushClickClientEvent> {
  /**
   * @generated from field: string web_push_type = 1;
   */
  webPushType = "";

  constructor(data?: PartialMessage<WebPushClickClientEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.WebPushClickClientEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "web_push_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WebPushClickClientEvent {
    return new WebPushClickClientEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WebPushClickClientEvent {
    return new WebPushClickClientEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WebPushClickClientEvent {
    return new WebPushClickClientEvent().fromJsonString(jsonString, options);
  }

  static equals(a: WebPushClickClientEvent | PlainMessage<WebPushClickClientEvent> | undefined, b: WebPushClickClientEvent | PlainMessage<WebPushClickClientEvent> | undefined): boolean {
    return proto3.util.equals(WebPushClickClientEvent, a, b);
  }
}

/**
 * Stored by client when user opens a new route.
 *
 * @generated from message gdx.gateway.web.myprofile.v1.RouteVisitedEvent
 */
export class RouteVisitedEvent extends Message<RouteVisitedEvent> {
  /**
   * @generated from field: string route = 1;
   */
  route = "";

  constructor(data?: PartialMessage<RouteVisitedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.RouteVisitedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "route", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RouteVisitedEvent {
    return new RouteVisitedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RouteVisitedEvent {
    return new RouteVisitedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RouteVisitedEvent {
    return new RouteVisitedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: RouteVisitedEvent | PlainMessage<RouteVisitedEvent> | undefined, b: RouteVisitedEvent | PlainMessage<RouteVisitedEvent> | undefined): boolean {
    return proto3.util.equals(RouteVisitedEvent, a, b);
  }
}

/**
 * User came back to site after browser's tab was closed.
 *
 * @generated from message gdx.gateway.web.myprofile.v1.CameBackEvent
 */
export class CameBackEvent extends Message<CameBackEvent> {
  /**
   * @generated from field: string landing_url = 1;
   */
  landingUrl = "";

  constructor(data?: PartialMessage<CameBackEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.CameBackEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "landing_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CameBackEvent {
    return new CameBackEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CameBackEvent {
    return new CameBackEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CameBackEvent {
    return new CameBackEvent().fromJsonString(jsonString, options);
  }

  static equals(a: CameBackEvent | PlainMessage<CameBackEvent> | undefined, b: CameBackEvent | PlainMessage<CameBackEvent> | undefined): boolean {
    return proto3.util.equals(CameBackEvent, a, b);
  }
}

